/** @format */

import React, {
  useEffect,
  useState,
  useRef,
  useContext,
  useCallback,
} from "react";
import { ListItem, ListItemIcon, ListItemText, styled } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import {
  Grid,
  Box,
  Typography,
  ThemeProvider,
  TextField,
  LinearProgress,
  CircularProgress,
  IconButton,
  List,
  Alert,
  Modal,
  Drawer,
  Skeleton,
} from "@mui/material";
import { useMediaQuery } from "@mui/material";
import { createTheme, createFilterOptions, Autocomplete } from "@mui/material";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import { useForm, FormProvider } from "react-hook-form";
import { useFeatureFlag } from "@harnessio/ff-react-client-sdk";
import { useLocation } from "react-router-dom";
import {
  getSkillsFromLocalStorage,
  formatSkillsForForm,
  clearSkillsFromLocalStorage,
  clearUrlParameters,
} from "./utils/skillsUtils";
import axios from "axios";
import CloseIcon from "@mui/icons-material/Close";
import _ from "lodash";

import toast, { Toaster, ToastBar } from "react-hot-toast";
import PotentialSalaryIncraeseChart from "./PotentialSalaryIncraeseChart";
import DeviceInfoAndLocation from "./global/DeviceInfoAndLocation";
import Joyride from "react-joyride";
import { OAuthCtx } from "./auth/AuthContext";
import { Auth } from "aws-amplify";
import { setupAuthInterceptor } from "./utils/apis";
import SignInModal from "./auth/components/SignIn";
import { getEmail, getUsername, setUserEmail } from "./utils/storage";
import LogoutIcon from "@mui/icons-material/Logout";
import MenuIcon from "@mui/icons-material/Menu";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import apis from "./utils/apis";
import { checkYearWithGpt, Legend } from "./utils/GlobalFunctions";
import { getExperiences } from "./Components/GlobalFunctions";
import { motion } from "framer-motion";
import GetQuestionForm from "./Components/common/GetQuestionForm";
import JobSuggestionDataCard from "./Components/common/JobSuggestionDataCard";
import FooterComponent from "./Components/Footer";
import { getQuestionForm } from "./Components/TechRelevance.helper";
import { setQuestionForm } from "./redux/action/questionForm";
import { logoutUser } from "./redux/action/auth";
import { useDispatch, useSelector } from "react-redux";
import Loading from "./Components/common/Loading";
import ErrorComponent from "./Components/common/Error";
import ai from "./Components/animations/ai.json";
import EmojiIcon from "./Components/common/EmojiIcon";
import InsightsSkeleton from "./Components/common/InsightsSkeleton";
import InsightsAnimation from "./Components/common/InsightsAnimation";
import GetInsights from "./Components/GetInsights";
import {
  fetchDisruptCareerData,
  fetchInterviewQuestions,
} from "./Components/techrelevance.apis/fetchInterviewQuestions";
import ReactGA4 from "react-ga4";
import {
  setAdvancedQuestion,
  setBasicQuestion,
  setIntermediateQuestion,
} from "./redux/action/interviewQuestions";
import SynonymsInfoBox from "./Components/common/SynonymousCard";
import useUserLocation from "./Components/UserLocation";
import {
  fetchCountries,
  fetchTopCities,
  fetchStates,
  fetchCities,
} from "./Components/techrelevance.apis/fetchSalaryRange";
import BookmarkNavigation from "./Components/BookmarkNavigation";
import {
  setUserState,
  setUserCity,
  setUserCountry,
  setUserStateList,
  setUserTopCities,
  setUserExperienceRange,
  setSalaryRange,
  setCountryList,
  setSalaryRangeSkeleton,
} from "./redux/action/userLocation";
import {
  fetchLocationData,
  fetchSalaryRangeFunction,
} from "./Components/common/FetchSalaryRange";
import { getCountriesList } from "./utils/GlobalFunctions";
import FeaturesCardSwiper from "./Components/common/FeaturesCardSwiper";
import TechRelevanceForm from "./Components/TechRelevanceForm";
import GlowBorderWrapper from "./Components/common/GlowBorderWrapper";

// Function to render custom icons
const renderCustomIcon = (iconName, size = 24) => {
  const iconPath = `/assets/images/bookmark-icons/${iconName}.svg`;
  return (
    <img
      src={iconPath}
      alt={iconName}
      style={{
        width: size,
        height: size,
        objectFit: "contain",
      }}
      onError={(e) => {
        // Fallback to Material-UI icon if custom icon fails to load
        console.warn(`Failed to load custom icon: ${iconName}`);
        e.target.style.display = "none";
      }}
    />
  );
};

function getFirstWord(inputString) {
  const words = inputString.split(" ");
  if (words.length > 0) {
    return words[0];
  } else {
    return "";
  }
}

function ScrollDown() {
  window.scrollTo({
    top: document.documentElement.scrollHeight,
    behavior: "smooth",
  });
}

function TechRelevanceV4() {
  const theme = useTheme();
  const dispatch = useDispatch();
  const routerLocation = useLocation();

  const { getAuthState } = useContext(OAuthCtx);
  const [errorWithStatus, setErrorWithStatus] = useState();

  const { getValues, setValue } = useForm();

  const relevenceTheme = createTheme({
    typography: {
      fontFamily: `"Montserrat", 'normal'`,
    },
    palette: {
      primary: {
        main: "rgba(108,82,229,1)",
      },
    },
  });
  relevenceTheme.typography.h1 = {
    fontSize: "3rem",
    lineHeight: "3rem",
    "@media (max-width:600px)": {
      fontSize: "2.2rem",
    },
    [relevenceTheme.breakpoints.up("md")]: {
      fontSize: "3rem",
    },
  };
  relevenceTheme.typography.h2 = {
    fontSize: "2.125rem",
    lineHeight: "2.125rem",

    "@media (max-width:600px)": {
      fontSize: "1.625rem",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "2rem",
    },
  };
  relevenceTheme.typography.h3 = {
    fontSize: "1.75rem",
    lineHeight: "1.75rem",

    "@media (max-width:600px)": {
      fontSize: "1.375rem",
    },
    [relevenceTheme.breakpoints.up("md")]: {
      fontSize: "1.6rem",
    },
  };
  relevenceTheme.typography.h4 = {
    fontSize: "1.5rem",
    lineHeight: "2rem",

    "@media (max-width:600px)": {
      fontSize: "1.25rem",
    },
    [relevenceTheme.breakpoints.up("md")]: {
      fontSize: "1.4rem",
    },
  };
  relevenceTheme.typography.h5 = {
    fontSize: "1.2rem",
    lineHeight: "1.5rem",

    "@media (max-width:600px)": {
      fontSize: "1rem",
    },
    [relevenceTheme.breakpoints.up("md")]: {
      fontSize: "1.4rem",
    },
  };
  relevenceTheme.typography.h6 = {
    fontSize: "1.2rem",
    lineHeight: "1.5rem",

    "@media (max-width:600px)": {
      fontSize: "1rem",
    },
    [relevenceTheme.breakpoints.up("md")]: {
      fontSize: "1.4rem",
    },
  };
  relevenceTheme.typography.h6 = {
    fontSize: "1.2rem",
    lineHeight: "1.5rem",

    "@media (max-width:600px)": {
      fontSize: "1rem",
    },
    [relevenceTheme.breakpoints.up("md")]: {
      fontSize: "1.4rem",
    },
  };
  const [selectedTab, setSelectedTab] = useState("advanced");
  const methods = useForm({ criteriaMode: "all" });
  const methodsJobSuggestion = useForm({ criteriaMode: "all" });
  const [UserName, setUserName] = useState("");
  const [loadingButton, setLoadingButton] = React.useState(false);
  const [relevanceResult, setRelevanceResult] = useState("");
  const [formdata, setFormdata] = useState("");
  const [chatGptButton, setChatGptButton] = useState(false);
  const [interviewQuestionsLoading, setInterviewQuestionsLoading] =
    useState(false);
  const [advancedQuestionsLoading, setAdvancedQuestionsLoading] =
    useState(false);
  const [intermediateQuestionsLoading, setIntermediateQuestionsLoading] =
    useState(false);
  const [basicQuestionsLoading, setBasicQuestionsLoading] = useState(false);
  const [advancedQuestions, setAdvancedQuestions] = useState([]);
  const [intermediateQuestions, setIntermediateQuestions] = useState([]);
  const [basicQuestions, setBasicQuestions] = useState([]);
  const [skill, setSkill] = useState({});
  const [checkSkill, setCheckSkill] = useState("");
  const [skillList, setSkillList] = useState();
  const [interviewQuestions, setInterviewQuestions] = useState("");
  const [disruptCareerData, setDisruptCareerData] = useState("");
  let initialCount = 1;
  const [chatGPTData, setChatGPTData] = useState("");
  const [chatgptError, setChatgptError] = useState(false);
  const staticRandomEncodeDecodeString = useFeatureFlag(
    "staticRandomEncodeDecodeString"
  );
  const secretEncodeDecodeString = useFeatureFlag("secretEncodeDecodeString");
  const poweredByChatGPT = useFeatureFlag("Chat_GPT_Boost");
  const CalculateButtonValue = useFeatureFlag("Calculate_Button_text");
  const [getInterviewQuestions, setGetInterviewQuestions] = useState(false);
  const apiTimeout = { timeout: 60000 };
  const [location, setLocation] = useState();
  const [deviceInfo, setDeviceInfo] = useState();
  const Hide_google_trends = useFeatureFlag("Hide_google_trends");
  const [shareLink, setShareLink] = useState(
    `${process.env.REACT_APP_BASE_URL}/signin`
  );
  const [targetElement, setTargetElement] = useState("relevance-result");
  const [relevanceTooltip, setRelevanceTooltip] = useState(false);
  const [run, setRun] = useState(false);
  const [insightsStep, setInsightsStep] = useState(false);
  const isMobile = useMediaQuery("(max-width:600px)");
  const [skillLength, setSkillLength] = useState(0);
  const [userExist, setUserExist] = useState(true);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const questionForm =
    useSelector((state) => state.questionFormReducer.questionForm) || [];
  const isAuthenticated = useSelector(
    (state) => state?.auth?.isAuthenticated
  );
  const [questions, setQuestions] = useState(questionForm);
  const [questionLoading, setQuestionLoading] = useState(false);
  const [disruptCareerLoading, setDisruptCareerLoading] = useState(false);
  let questionsApiCalled = false;
  const [videoLoaded, setVideoLoaded] = useState(false);
  const [closeJobForm, setCloseJobForm] = useState(false);
  const [subSkills, setSubSkills] = useState([]);
  const [errorAPI, setErrorAPI] = useState(false);
  const [synonyms, setSynonyms] = useState([]);
  const advancedQuestionsStore =
    useSelector((state) => state?.interviewQuestions?.advancedQuestions) || [];

  const intermediateQuestionsStore =
    useSelector((state) => state?.interviewQuestions?.intermediateQuestions) ||
    [];

  const basicQuestionsStore =
    useSelector((state) => state?.interviewQuestions?.basicQuestions) || [];
  const [processingSkill, setProcessingSkill] = useState(null);
  const userLocationDenied = localStorage.getItem("userLocationDenied");
  const [userData, setUserData] = React.useState("");
  const userCurrentState = useSelector(
    (state) => state.UserLocationReducer.userState
  );
  const userCurrentCity = useSelector(
    (state) => state.UserLocationReducer.userCity
  );
  const userCurrentCountry = useSelector(
    (state) => state.UserLocationReducer.userCountry
  ) || { name: "India", shortName: "IN" };
  const { address } = useUserLocation();
  // State for user location selection
  const [openCountryModal, setOpenCountryModal] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedState, setSelectedState] = useState(null);
  const countries = useSelector(
    (state) => state.UserLocationReducer.countriesList
  );
  const userCountry = useSelector(
    (state) => state.UserLocationReducer.userCountry
  );
  const userExperienceRange =
    useSelector((state) => state.UserLocationReducer.userExperienceRange) || [];
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [isFirstTimeUser, setIsFirstTimeUser] = useState(false);
  const [isStateLoading, setIsStateLoading] = useState(false);
  const userLocationSet = localStorage.getItem("userLocationSet");
  const [selectedSkill, setSelectedSkill] = useState("");
  const [showInsightsAnimation, setShowInsightsAnimation] = useState(false);

  const isFetchingRef = useRef(false); // Tracks if API is already being called
  const defaultUserExperienceRange = userExperienceRange?.slice(0, 7);
  const userStateList = useSelector(
    (state) => state.UserLocationReducer.userStateList
  );
  const userState = useSelector((state) => state.UserLocationReducer.userState);

  const fetchQuestions = useCallback(() => {
    fetchInterviewQuestions(
      dispatch,
      skill,
      advancedQuestionsStore,
      intermediateQuestionsStore,
      basicQuestionsStore,
      setAdvancedQuestions,
      setIntermediateQuestions,
      setBasicQuestions,
      setInterviewQuestions,
      setInterviewQuestionsLoading,
      setAdvancedQuestionsLoading,
      setIntermediateQuestionsLoading,
      setBasicQuestionsLoading,
      selectedTab
    );
  }, [skill, selectedTab]);

  useEffect(() => {
    fetchQuestions();
  }, [fetchQuestions]);

  // Auto-click "Ask AI" for top skill after 4 seconds
  useEffect(() => {
    if (relevanceResult?.topPrimarySkill?.length > 0) {
      const topSkill = getTopSkill(
        relevanceResult.topPrimarySkill
      ).maxExpiryYearObject;
      if (topSkill) {
        const timer = setTimeout(() => {
          handleSendClick(topSkill);
        }, 1000);
        return () => clearTimeout(timer); // Cleanup timeout
      }
    }
  }, [relevanceResult]);

  const handleVideoLoaded = () => {
    setVideoLoaded(true);
  };

  const fetchUserSession = async () => {
    try {
      const userAuthenticated = await getAuthState();
      if (userAuthenticated !== null) {
        setupAuthInterceptor(getAuthState);
        // Track successful social login (Google/LinkedIn):
        // In production, Cognito OAuth redirects directly to /skill-relevance rather than HomePage.
        // We check and clear 'clickedSocialMediaLogin' from sessionStorage to fire 'login_completed' exactly once.
        const clickedSocialMediaLogin = sessionStorage.getItem(
          "clickedSocialMediaLogin"
        );
        if (clickedSocialMediaLogin) {
          sessionStorage.removeItem("clickedSocialMediaLogin");
          ReactGA4.event("login_completed", { method: "social" });
        }
        const userCreated = sessionStorage.getItem("userCreated");
        if (userCreated === null && isLoggedIn) {
          const payload = {
            email: getEmail(),
            registerTime: new Date(Date.now()).toUTCString(),
            lastLoginTime: new Date(Date.now()).toUTCString(),
            userOf: "relevance",
          };
          apis
            .POST({
              endpoint: "/create-user",
              payload: payload,
              options: { type: "json" },
            })
            .then((object) => {
              // console.log(object.data);
              setLoading(false);
              sessionStorage.setItem("userCreated", true);
            })
            .catch((error) => {
              sessionStorage.setItem("userCreated", true);
              // console.log(error);
              setLoading(false);
            });
        }
      } else {
        localStorage.clear();
        sessionStorage.clear();
        setLoading(false);
      }
      return getAuthState;
    } catch (error) {
      console.error("Error fetching user session:", error);
      setLoading(false);
    }
  };

  const isLoggedIn = Boolean(isAuthenticated);

  function randomIntFromInterval(min, max) {
    // min and max included
    return Math.floor(Math.random() * (max - min + 1) + min);
  }

  const PotentialSalaryIncraese = [
    "10",
    "20",
    "30",
    "15",
    "20",
    "30",
    "15",
    "30",
  ];

  const easeOfLearning = ["Easy", "Medium", "Hard"];
  //  check user logged or not

  useEffect(() => {
    if (!isLoggedIn) return;

    fetchUserSession();
    // Only call the API if user is logged in and questions haven't been fetched yet
    const timer = setTimeout(() => {
      if (questionForm.length === 0) {
        questionsApiCalled = true;
        setQuestionLoading(true);
        getQuestionForm(
          setQuestions,
          setQuestionLoading,
          dispatch,
          setQuestionForm,
          setLoading
        );
      }
    }, 3000);
    return () => clearTimeout(timer);
  }, [isLoggedIn, questionForm.length, dispatch]);

  useEffect(() => {
    if (!isLoggedIn) {
      window.location.replace("/");
    }
  }, [isLoggedIn]);

  useEffect(() => {
    getUserInfo();

    if (isLoggedIn) {
      setLoading(false);
      const element = document?.getElementById("enter-your-skills");
      element?.scrollIntoView();
    }
    const userType = sessionStorage.getItem("userType");
    if (userType === "user-auth") {
      const element = document?.getElementById("enter-your-skills");
      element?.scrollIntoView();
    }
    if (!isLoggedIn) {
      setRelevanceResult("");
      // setLoading(false);
      const pageLoading = setTimeout(() => {
        setLoading(false);
      }, 2500);
      return () => clearTimeout(pageLoading);
    }
  }, []);

  useEffect(() => {
    if (!isLoggedIn) return;
    if (isLoggedIn && address !== null) {
      isFetchingRef.current = true;
      getCountriesList(
        dispatch,
        address,
        countries,
        stateList,
        userExperienceRange
      ).finally(() => {
        isFetchingRef.current = false;
      });
    }

    const popupOpen = setTimeout(() => {
      if (address === null) {
        if (userLocationSet === "false" && countries.length > 0) {
          setOpenCountryModal(true);
        }
      } else {
        localStorage.setItem("userLocationSet", "true");
      }
    }, 1000);

    return () => clearTimeout(popupOpen);
  }, [isLoggedIn]);

  // Reset animation state when component mounts
  useEffect(() => {
    setShowInsightsAnimation(false);
  }, []);

  // Reset animation state when relevance result changes
  useEffect(() => {
    if (relevanceResult) {
      setShowInsightsAnimation(false);
    }
  }, [relevanceResult]);

  useEffect(() => {
    if (
      (countries === undefined || countries === null) &&
      isLoggedIn &&
      !isFetchingRef.current
    ) {
      isFetchingRef.current = true;
      fetchCountriesList().finally(() => {
        isFetchingRef.current = false;
      });
    }
  }, [isLoggedIn, countries]);

  // Handlers for user location selection
  const fetchCountriesList = async () => {
    try {
      dispatch(setSalaryRangeSkeleton(true));
      const { countries, experienceRange } = await fetchCountries();
      setCountryList(countries);
      dispatch(setCountryList(countries));
      dispatch(setUserExperienceRange(experienceRange));
      dispatch(setSalaryRangeSkeleton(false));
    } catch (error) {
      console.error("Failed to fetch countries:", error);
      dispatch(setSalaryRangeSkeleton(false));
      toast.error("Failed to fetch countries. Please try again.");
    }
  };

  const fetchStatesList = async (country) => {
    try {
      setIsStateLoading(true);

      const { states } = await fetchStates(country);
      setStateList(states);

      dispatch(setUserStateList(states));
      setIsStateLoading(false);
    } catch (error) {
      console.error("Failed to fetch states:", error);
      toast.error("Failed to fetch states. Please try again.");
    }
  };

  const fetchCitiesList = async (country, state) => {
    try {
      const { cities } = await fetchTopCities(country, state);
      setCityList(cities);
      dispatch(setUserState(state));
      dispatch(setUserTopCities(cities));
      fetchCities(state, dispatch);

      if (isFirstTimeUser && cities.length > 0) {
        const defaultCity = {
          name: country.capitalCity,
          countryShortName: country.shortName,
        };
        dispatch(setUserCity(defaultCity));
        localStorage.setItem("userLocationSet", "true");
      }
    } catch (error) {
      console.error("Failed to fetch top cities:", error);
      // toast.error("Failed to fetch cities. Please try again.");
    }
  };

  const handleCountrySelect = async (country) => {
    setSelectedCountry(country);
    dispatch(setUserCountry(country));
    const userState = {
      name: country.capitalState,
      stateCode: country.stateCode,
      countryShortName: country.shortName,
    };
    dispatch(setUserState(userState));
    await fetchStatesList(country);
    setSelectedState(null);
    setCityList([]);
  };

  const handleStateSelect = async (state) => {
    setSelectedState(state);
    await fetchCitiesList(selectedCountry, state);
  };
  const [shouldSubmitLocation, setShouldSubmitLocation] = useState(false);

  const handleModalSubmit = () => {
    const missingFields = [];
    if (selectedCountry === null) missingFields.push("country");
    if (selectedState === null) missingFields.push("state");

    if (missingFields.length > 0) {
      toast.error(`Please select a ${missingFields.join(" and ")}.`);
      return;
    }

    setOpenCountryModal(false);
    setShouldSubmitLocation(true); // Trigger effect when cityList is ready
  };

  useEffect(() => {
    if (shouldSubmitLocation && cityList?.length > 0) {
      const userCity = selectedCountry.capitalState;
      try {
        fetchSalaryRangeFunction(
          selectedSkill,
          defaultUserExperienceRange,
          selectedState,
          userCity, // ensure index 2 exists
          selectedCountry,
          dispatch
        );

        const defaultCity = {
          name: selectedCountry.capitalCity,
          countryShortName: selectedCountry,
        };

        dispatch(setUserCity(defaultCity));
        localStorage.setItem("userLocationSet", "true");
      } catch (error) {
        console.error("Error in city handling:", error);
        toast.error("Failed to save location. Please try again.");
      } finally {
        setShouldSubmitLocation(false); // Reset flag
      }
    }
  }, [shouldSubmitLocation, cityList]);

  const defaultLocation = {
    country: { name: "India", shortName: "IN", currencySymbol: "₹" },
    state: { name: "Delhi", countryShortName: "IN", stateCode: "DL" },
    city: { name: "Delhi", countryShortName: "IN" },
  };

  const handleCloseModal = () => {
    setOpenCountryModal(false);
    localStorage.setItem("userLocationDenied", "true");
    dispatch(setUserCountry(defaultLocation.country));
    dispatch(setUserCity(defaultLocation.city));
    dispatch(setUserState(defaultLocation.state));
    fetchStatesList(defaultLocation.country);
    const fetchSalaries = setTimeout(() => {
      fetchSalaryRangeFunction(
        selectedSkill,
        defaultUserExperienceRange,
        defaultLocation.state,
        defaultLocation.city,
        defaultLocation.country,
        dispatch
      );
    }, 1000);
    return () => clearTimeout(fetchSalaries);
  };

  const getUserInfo = async () => {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const idTokenPayload = user.signInUserSession.idToken.payload;

      // Extract user information from idTokenPayload
      const email = idTokenPayload.email;
      setUserEmail(email);
      const name =
        idTokenPayload.name ||
        `${idTokenPayload.given_name || ""} ${
          idTokenPayload.family_name || ""
        }`.trim();
    } catch (error) {
      console.error("Error getting user info:", error);
    }
  };

  const introSteps = [
    {
      target: ".technical-validity-box",
      content:
        "💼 Unleash your potential! Our 'Technical Validity' feature validates the authenticity and proficiency of your top skill ✅, helping you build trust and credibility in your professional network.",
    },
    {
      target: ".skill-score",
      content:
        "Meet our Skill Score feature! It's like a crystal ball 🔮 for your skills, showing you their demand status in the industry with estimate year and how widely they're adopted by different companies. It's your guide to navigating the job market with confidence!",
    },
    {
      target: ".get-insights",
      content:
        "Ready for more? Hit 'Ask AI' for enterprise adoption 🏢, skill popularity 🎓, and potential salary boosts 💰. Let's uncover your path to success! 🌟",
    },
  ];

  const InsightsSteps = [
    {
      target: ".skill-popularity",
      content:
        "📊 Skill popularity with ease! Our module rates skills on a scale of 1 to 10, showcasing their popularity among learners 🎓",
    },
    {
      target: ".sub-skills",
      content:
        "🔍 Dive into skill mastery! Explore detailed subskills for each skill, ranked by ease of learning 🧠 and relevance 🌟 to help you progress faster and smarter 🚀.",
    },
    {
      target: ".enterprise-adoption",
      content:
        "Discover 🏢 industry demand at a glance! Our Enterprise Adoption module rates skills on a scale of 0 to 100%, giving you a clear picture of their acceptance among businesses",
    },
    {
      target: ".lear-earn-recommendations",
      content: `Unlock 📚 learning opportunities and potential earnings! Our Latest Technologies feature suggests how many skills you can acquire alongside your chosen skill. Click '${
        isMobile ? ":" : "learn more"
      }' to uncover these valuable suggestions and chart your path to success! 🌟`,
    },
    {
      target: ".suggested-roles",
      content:
        "🎯 Discover suggested roles that align with your skills and experience, offering potential career paths and salary insights.",
    },
    {
      target: ".other-roles",
      content:
        "🧭 Explore other roles you might be suited for based on your current skills, providing a broader view of your career options.",
    },
    {
      target: ".courses-section",
      content:
        "📚 Accelerate your learning journey! Access curated learning resources from YouTube 🎥, Google 🔍, Gemini 🤖, and ChatGPT 💬. Find the best tutorials, courses, and AI-powered guidance to master your chosen skill faster and smarter! 🚀",
    },
    {
      target: ".higher-roles",
      content:
        "🚀 Learn about higher roles you can aim for, including promotions and the skills required to reach them.",
    },
    {
      target: ".annual-income-experience",
      content:
        "📈 See how your annual income might increase with more years of experience in your field.",
    },
    {
      target: ".annual-income-city",
      content:
        "🌍 Compare annual incomes across different cities and states to understand regional salary variations.",
    },
    // {
    //   target: ".job-suggestion-box",
    //   content:
    //     "Unlock your next career step! Based on your IT experience, preferred office location, and chosen primary role, discover job opportunities that match your skills 🖥️, ideal work setting 🌍, and growth potential 🚀. Ready to find the perfect fit? Let's dive in! 🎯",
    // },
    {
      target: ".interview-questions",
      content:
        "🎯 Ace your interviews with confidence! Discover the most asked questions 🗣️, tailored to your skillset and industry 🌍, helping you prepare like a pro 📚 and shine in your career path ✨.",
    },
    {
      target: ".disrupt-career-box",
      content:
        "🚀 Unlock transformative opportunities! Identify game-changing trends 🔮, essential skills 🛠️, and insights that can elevate your career to the next level 🌟 and keep you ahead of the curve 📈.",
    },
  ];

  function checkSkillType(year) {
    const currentYear = new Date().getFullYear();
    const minYearDiff = 5;
    const minYearForCurrentSkill = 1;
    const minYearForOutdated = 4;
    if (year > currentYear) {
      return `Skill trending and in demand until ${year}`;
    } else if (year >= currentYear - minYearForCurrentSkill) {
      return `Skill current and in demand until ${year}`;
    } else if (year >= currentYear - minYearForOutdated) {
      return `Skill getting outdated fast ${year}`;
    } else if (year <= currentYear - minYearDiff) {
      return `Skill obselete ${year}`;
    }
  }
  useEffect(() => {
    setLoading(true);
    axios
      .get(
        process.env.REACT_APP_API_BASE_URL + `/get-relevanceSkill?skills=java`,
        {}
      )
      .then((object) => {
        setLoading(false);
      });
  }, []);

  useEffect((item) => {
    DeviceInfoAndLocation(setLocation, setDeviceInfo);
  }, []);

  function checkYear(year) {
    const currentYear = new Date().getFullYear();
    const minYearDiff = 5;
    const minYearForOutdatedSkill = 4;
    const minYearForCurrentSkill = 1;

    if (year > currentYear) {
      const labelSuggestion = (
        <Typography
          sx={{
            fontFamily: "Montserrat",
            color: "#232323",
          }}
          variant="h6"
        >
          <span
            style={{
              fontWeight: 700,
              color: "#26801E",
            }}
          >
            Trending{" "}
          </span>{" "}
          : You are in demand, but keep upgrading
        </Typography>
      );
      return {
        label: `Technical skill trending and in demand until ${year}`,
        barPrimaryColor: "#278C37",
        barSecondaryColor: "#9ad7a3",
        labelSuggestion,
        percentageColor: "#278C37",
      };
    } else if (year >= currentYear - minYearForCurrentSkill) {
      const labelSuggestion = (
        <Typography
          sx={{
            fontFamily: "Montserrat",
            fontSize: "20px",
            color: "#232323",
            mb: "47px",
          }}
        >
          <span
            style={{
              fontSize: "20px",
              fontWeight: 700,
              color: "darkorange",
            }}
          >
            • In demand
          </span>{" "}
          <spna>
            : Your skill is in demand, but it’s getting outdated fast.
          </spna>
        </Typography>
      );
      return {
        label: `Technical skill in demand until ${year}`,
        barPrimaryColor: "#E9B112",
        barSecondaryColor: "#f5e7be",
        labelSuggestion,
        percentageColor: "#E9B112",
      };
    } else if (year >= currentYear - minYearForOutdatedSkill) {
      const labelSuggestion = (
        <Typography
          sx={{
            fontFamily: "Montserrat",
            fontSize: "20px",
            color: "#232323",
            mb: "47px",
          }}
        >
          <span
            style={{
              fontSize: "20px",
              fontWeight: 700,
              color: "#ffc107",
            }}
          >
            • Getting outdated
          </span>{" "}
          <span>: Upskill soon to stay ahead in the industry.</span>
        </Typography>
      );
      return {
        label: `Technical skill getting outdated fast ${year}`,
        barPrimaryColor: "#C60015",
        barSecondaryColor: "#ffa7b0",
        labelSuggestion,
        percentageColor: "#C60015",
      };
    } else if (year <= currentYear - minYearDiff) {
      const labelSuggestion = (
        <Typography
          sx={{
            fontFamily: "Montserrat",
            fontSize: "24px",
            color: "#232323",
            mb: "47px",
          }}
        >
          <span
            style={{
              fontSize: "20px",
              fontWeight: 700,
              color: "red",
            }}
          >
            • Obsolete
          </span>{" "}
          : Please learn new age skills now
        </Typography>
      );
      return {
        label: `Technical skill obselete ${year}`,
        barPrimaryColor: "#028EDF",
        barSecondaryColor: "#b7e5ff",
        labelSuggestion,
        percentageColor: "#028EDF",
      };
    }
  }

  function getTopSkill(skillArray) {
    let maxExpiryYear = -Infinity;
    let maxExpiryYearObject = null;

    // Iterate through the array
    for (const obj of skillArray) {
      if (
        obj.expiryYear > maxExpiryYear &&
        obj.expiryYear !== null &&
        obj.expiryYear < new Date().getFullYear() + 25
      ) {
        maxExpiryYear = obj.expiryYear;
        maxExpiryYearObject = obj;
      } else {
        if (obj?.expiryYear > new Date().getFullYear() + 100) {
          maxExpiryYear = parseFloat(obj?.estYear) + 10;
          maxExpiryYearObject = {
            ...obj,
            expiryYear: parseFloat(obj?.estYear) + 15,
          };
        } else if (obj?.estYear === null || obj.estYear === undefined) {
          maxExpiryYear = new Date().getFullYear() + 2;
          maxExpiryYearObject = {
            ...obj,
            expiryYear: new Date().getFullYear() + 2,
          };
        }
      }
    }
    const topSkillSuggestion = checkYear(maxExpiryYearObject?.expiryYear);

    return {
      maxExpiryYear,
      labelSuggestion: topSkillSuggestion?.labelSuggestion,
      maxExpiryYearObject,
    };
  }

  // Data Encryption function
  function DataEncryption(json) {
    const jsonString = JSON.stringify(json);
    const customStringJson =
      secretEncodeDecodeString + jsonString + secretEncodeDecodeString;
    const newCustomStringJson = customStringJson.replace(
      /"/g,
      staticRandomEncodeDecodeString
    );

    // Convert the string to UTF-8 encoding
    const utf8EncodedString = new TextEncoder().encode(newCustomStringJson);

    // Convert the UTF-8 array to a string in chunks
    let utf8String = "";
    for (let i = 0; i < utf8EncodedString.length; i += 10000) {
      utf8String += String.fromCharCode(
        ...utf8EncodedString.slice(i, i + 10000)
      );
    }

    const base64EncodedString = btoa(utf8String);
    return base64EncodedString;
  }
  function DataDecryption(jsonString) {
    const decodedString = atob(jsonString);
    const getOldStringOne = decodedString.replace(
      new RegExp(secretEncodeDecodeString, "g"),
      ""
    );
    const str = staticRandomEncodeDecodeString;
    const escapedString = str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const regex = new RegExp(escapedString, "g");
    const getOldStringTwo = getOldStringOne.replace(regex, '"');
    const json = JSON.parse(getOldStringTwo);
    return json;
  }

  // state for handle logout button
  const [openLogout, setOpenLogout] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const isSmallDevice = useMediaQuery("(max-width: 960px)");
  const [addSkill, setAddSkill] = useState(false);
  const [shouldAutoFocus, setShouldAutoFocus] = React.useState(false);

  const handleOpen = () => setOpenLogout(true);
  const handleClose = () => setOpenLogout(false);

  const handleLogout = async () => {
    try {
      await dispatch(logoutUser());
    } catch (error) {
      console.error("Error during logout:", error);
    }

    localStorage.clear();
    sessionStorage.clear();
    setLoading(true);
    setOpenLogout(false);

    setTimeout(() => {
      setLoading(false);
      questionsApiCalled = false;
      window.location.replace("/");
    }, 1500);
  };
  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setDrawerOpen(open);
  };

  // tech relevance handler
  const onSubmit = async (data) => {
    // Guard 1: Prevent multiple simultaneous submissions
    if (isSubmittingRef.current && loadingButton) {
      return;
    }

    if (autoValue.length === 0) {
      methods.setError("primarySkill", {
        type: "required",
        message: `Please Enter a skill`,
      });
      setRelevanceResult("");
      return;
    }
    const userSession = await fetchUserSession();
    setJobSuggestionData("");
    setIsButtonClicked(false);

    if (
      (autoValue.length !== 0 && userSession !== undefined) ||
      userSession !== null
    ) {
      setUserExist(true);

      // Guard 2: Set submitting flag before any async operations
      isSubmittingRef.current = true;
      setLoadingButton(true);
      const userName = getUsername();
      setUserName(userName || "Your");
      setErrorAPI(false);
      setFormdata(data);
      setSkill({});
      setCheckSkill("");
      setGetInterviewQuestions(false);
      data.email = getEmail();
      data.userLocation = location;
      data.deviceInfo = deviceInfo;
      data.primarySkill = data.primarySkill;

      setTargetElement("relevance-result");
      setSkillLength(methods.getValues("primarySkill")?.length);
      methodsJobSuggestion.reset();
      setShouldAutoFocus(false);

      try {
        axios
          .post(
            process.env.REACT_APP_API_BASE_URL + "/get-relevanceResult",
            DataEncryption(data),
            {
              options: {
                type: "json",
              },
            }
          )
          .then((object) => {
            const data = DataDecryption(object.data);
            setAddSkill(false);
            setRelevanceResult(data);
            setSkillList(data?.topPrimarySkill);
            setUserExist(data?.userExist);
            setLoadingButton(false);
            setShouldAutoFocus(false);
            // textFieldRef.current = false;

            // Track key conversion event in GA4 only when result is successfully saved to MongoDB
            if (data?.relevanceResultId) {
              ReactGA4.event("check_relevance_dashboard", {
                primary_skill: data?.topPrimarySkill?.[0]?.name || "",
                relevance_result_id: data.relevanceResultId,
              });
            }

            // Reset submitting flag on success
            isSubmittingRef.current = false;

            const joyride = setTimeout(() => {
              setRun(true);
              setUserExist(data?.userExist);
            }, 1000);

            return () => clearTimeout(joyride);
          })
          .catch((error) => {
            let errorMessage = "An unexpected error occurred";
            let errorStatus = null;

            // Handle API-specific errors
            if (error?.response) {
              errorStatus = error.response.status;

              if (
                errorStatus === 500 &&
                error?.response?.data?.message === "Email verification failed"
              ) {
                errorMessage = "Email not valid !!";
                methods.setError("email", {
                  type: "validation",
                  message: errorMessage,
                });
                setRelevanceResult("");
              } else if (errorStatus === 404) {
                errorMessage = "API endpoint not found";
              } else if (errorStatus >= 400) {
                errorMessage = "Client-side error occurred";
              } else if (errorStatus >= 500) {
                errorMessage = "Internal server error occurred";
              }
            } else {
              // Handle network errors
              errorMessage = "Network error, please check your connection";
            }
            setErrorWithStatus({ message: errorMessage, status: errorStatus });
            setErrorAPI(true);
            setLoadingButton(false);
            // Reset submitting flag on error
            isSubmittingRef.current = false;
          });
      } catch (error) {
        setErrorWithStatus({
          message: "An unexpected error occurred",
          status: null,
        });
        setLoadingButton(false);
        setErrorAPI(true);
        // Reset submitting flag on error
        isSubmittingRef.current = false;
      }
    }
  };

  const [JobSuggestionData, setJobSuggestionData] = useState("");
  const [formVisible, setFormVisible] = useState(true);
  const [questionFormLoading, setQuestionFormLoading] = useState(false);
  const [isButtonClicked, setIsButtonClicked] = useState(false);

  const onQuestionSubmit = async (data) => {
    sessionStorage.setItem("userAnswers", JSON.stringify(data));
    const userSession = await fetchUserSession();
    if (userSession !== undefined || userSession !== null) {
      data.primarySkill = autoValue;
      data.experience = getExperiences(data.experience);
      setQuestionFormLoading(true);
      // console.log("autoValue", autoValue);
      try {
        axios
          .post(
            process.env.REACT_APP_API_BASE_URL + "/get-job-suggestions",
            DataEncryption(data),
            {
              options: {
                type: "json",
              },
            }
          )
          .then((object) => {
            const data = DataDecryption(object.data);
            setJobSuggestionData(data?.JobSuggestionData);
            setFormVisible(false);
            setQuestionFormLoading(false);
            // console.log("Data of relevance", data);
          })
          .catch((error) => {
            if (
              error?.response?.status === 500 &&
              error?.response?.data?.message === "Email verification failed"
            ) {
              methods.setError("email", {
                type: "validation",
                message: "Email not valid !!",
              });
              // setRelevanceResult("");
            }
          });
      } catch (error) {
        // console.log(error);
        setQuestionFormLoading(false);
      }
    }
  };

  // chatgpt response handler
  const handleSendClick = async (item) => {
    setProcessingSkill(item.name); // Set the skill being processed
    setShowInsightsAnimation(true); // Show the animation
    dispatch(setAdvancedQuestion([]));
    dispatch(setIntermediateQuestion([]));
    dispatch(setBasicQuestion([]));
    setInterviewQuestionsLoading(true);
    setAdvancedQuestionsLoading(true);
    setIntermediateQuestionsLoading(true);
    setBasicQuestionsLoading(true);
    setChatgptError(false);
    setSkill(item);
    setCheckSkill(item?.name);
    setSubSkills(item?.subSkill);
    setGetInterviewQuestions(false);
    setTargetElement("chat-gpt-result");
    setSelectedSkill(item.name);
    methodsJobSuggestion.reset();

    const skillName = item.name;
    if (userLocationDenied === "true" || userLocationSet === "true") {
      fetchSalaryRangeFunction(
        skillName,
        defaultUserExperienceRange,
        userCurrentState,
        userCurrentCity,
        userCurrentCountry,
        dispatch
      );
    }

    if (
      (userLocationSet === "denied" &&
        countries.length > 0 &&
        userLocationDenied === null) ||
      userLocationDenied === undefined
    ) {
      setOpenCountryModal(true);
    }

    if (userExist) {
      setInsightsStep(false);
    }
    setSelectedTab("advanced");
    try {
      setChatGptButton(true);

      if (cancelToken) {
        cancelToken.cancel("Previous request cancelled");
      }

      cancelToken = axios.CancelToken.source();

      axios
        .post(
          process.env.REACT_APP_API_BASE_URL + "/get-chatgpt-response",
          DataEncryption({
            skillName: item?.name,
            resultId: relevanceResult?.relevanceResultId,
          }),
          {
            cancelToken: cancelToken.token,
            options: {
              type: "json",
            },
          }
        )
        .then((object) => {
          setChatGptButton(false);
          setProcessingSkill(null); // Reset the processing state
          const data = DataDecryption(object.data);
          let gptdata = JSON.parse(data?.result);
          ScrollDown();

          if (!gptdata || Object.keys(gptdata).length === 0) {
            setChatgptError(true);
            setChatGPTData("");
            toast.error("No data available, please try again.");
            setShowInsightsAnimation(false); // Stop animation on error
          } else {
            // Track key conversion event in GA4 only when AI response succeeds
            ReactGA4.event("ask_ai_dashboard", {
              skill_name: item.name,
              relevance_result_id: relevanceResult?.relevanceResultId || "",
            });

            setChatGPTData(gptdata);
            setInsightsStep(true);
            setShowInsightsAnimation(false); // Stop the animation when data loads
          }
        })
        .catch((error) => {
          setProcessingSkill(null); // Reset the processing state
          if (axios.isCancel(error)) {
            console.info("Request canceled:", error.message);
          } else {
            let errorMessage = "Something went wrong. Please try again.";
            if (error?.response) {
              if (error.response.status === 500) {
                errorMessage = "Server error occurred. Please try again later.";
              } else if (error.response.status === 404) {
                errorMessage = "Endpoint not found. Please check the URL.";
              } else if (error.response.status >= 400) {
                errorMessage = "Client-side error occurred.";
              }
            } else {
              errorMessage = "Network error, please check your connection.";
            }

            setChatgptError(true);
            toast.error(errorMessage);
            setTimeout(() => {
              setChatGptButton(false);
            }, 2000);
            setErrorAPI(true);
            setRelevanceResult("");
            setShowInsightsAnimation(false); // Stop animation on error
          }
        });
    } catch (error) {
      setProcessingSkill(null); // Reset the processing state
      setChatgptError(true);
      toast.error("An unexpected error occurred. Please try again.");
      setTimeout(() => {
        setChatGptButton(false);
      }, 2000);
      setErrorAPI(true);
      setRelevanceResult("");
      setShowInsightsAnimation(false); // Stop animation on error
      console.error("Unexpected Error:", error);
    }

    fetchDisruptCareerData(
      item,
      relevanceResult,
      setDisruptCareerData,
      setDisruptCareerLoading
    );
  };

  const handleAnimationComplete = () => {
    setShowInsightsAnimation(false);
  };

  const RetryGPT = (name) => {
    if (initialCount <= 3) {
      initialCount += 1;
      handleSendClick(name);
    } else {
      return;
    }
  };

  // scroll down hook
  useEffect(() => {
    const element = document?.getElementById(targetElement);
    element?.scrollIntoView({ behavior: "smooth", block: "start" });
  }, [chatGptButton, relevanceResult]);
  const [topSkillValidity, setTopSkillValidity] = useState([]);
  const [skillLoading, setSkillLoading] = useState(false);
  const [autoValue, setAutoValue] = useState(getValues("primarySkill") || []); // if dropdown open?
  const [shouldAutoClick, setShouldAutoClick] = useState(false); // Track if we should auto-click the button
  const [skillValidationComplete, setSkillValidationComplete] = useState(false); // Track if skill validation is complete
  const autoClickExecutedRef = useRef(false); // Persistent flag to prevent any duplicate auto-clicks
  const isSubmittingRef = useRef(false); // Persistent flag to prevent simultaneous submissions
  const skillsProcessedRef = useRef(false); // Track if skills from localStorage have been processed
  const mountValidationRef = useRef(false); // Track if mount validation has been performed

  // Callback to handle skill validation completion
  const handleSkillValidationComplete = useCallback(() => {
    setSkillValidationComplete(true);
  }, []);

  // Handle skills from localStorage when navigating to skill-relevance route
  useEffect(() => {
    // Only process skills if we're on the skill-relevance route and haven't processed them yet
    if (routerLocation.pathname !== "/skill-relevance" || skillsProcessedRef.current) {
      return;
    }

    // Check for skills in localStorage
    const skillsFromStorage = getSkillsFromLocalStorage();

    if (skillsFromStorage.length > 0) {
      // Mark as processed to prevent re-processing
      skillsProcessedRef.current = true;

      // Format skills for the form
      const formattedSkills = formatSkillsForForm(skillsFromStorage);

      // Force the validation API to run by temporarily clearing and setting skills
      setAutoValue([]);

      // Small delay to ensure the clear takes effect and component is ready
      setTimeout(() => {
        setAutoValue(formattedSkills);
        setValue("primarySkill", formattedSkills);

        // Set flag to trigger skill validation API for proper styling
        setAddSkill(true);

        // Enable auto-click ONLY if it hasn't been executed yet
        if (!autoClickExecutedRef.current) {
          setShouldAutoClick(true);
        }
      }, 200);

      // Clear the skills from localStorage after populating
      clearSkillsFromLocalStorage();
    }

    // Always clean up URL parameters when reaching the skill-relevance page
    clearUrlParameters();
  }, [routerLocation.pathname, setValue]); // Run when location changes or component mounts

  // Check and validate existing skills on component mount (for CVScore redirect scenario)
  // This only runs when handling skills from CVScore redirect (when skillsProcessedRef is set)
  useEffect(() => {
    // Only run on skill-relevance route, only once, and only in CVScore redirect scenario
    if (
      routerLocation.pathname !== "/skill-relevance" ||
      mountValidationRef.current ||
      skillLoading ||
      !skillsProcessedRef.current // Only run if we're in CVScore redirect flow
    ) {
      return;
    }

    // Small delay to ensure skills are set from localStorage first
    const checkTimer = setTimeout(() => {
      // Get current skills from form and autoValue
      const primarySkillFromForm = methods.getValues("primarySkill") || [];
      const currentAutoValue = autoValue || [];

      // Check if we have skills that need validation
      // Skills need validation if they only have 'name' property (not validated yet)
      // Validated skills have properties like imgPath, estYear, score, etc.
      const hasUnvalidatedSkills =
        (primarySkillFromForm.length > 0 &&
          primarySkillFromForm.some(
            (skill) => skill && skill.name && (!skill.imgPath && !skill.estYear && skill.score === undefined)
          )) ||
        (currentAutoValue.length > 0 &&
          currentAutoValue.some(
            (skill) => skill && skill.name && (!skill.imgPath && !skill.estYear && skill.score === undefined)
          ));

      // Only validate if we have unvalidated skills and haven't validated them yet
      if (hasUnvalidatedSkills && topSkillValidity.length === 0) {
        // Use the skills from autoValue if available, otherwise use primarySkill from form
        const skillsToValidate =
          currentAutoValue.length > 0 ? currentAutoValue : primarySkillFromForm;

        if (skillsToValidate.length > 0) {
          mountValidationRef.current = true;
          setSkillLoading(true);

          // Call the validation API
          axios
            .post(
              process.env.REACT_APP_API_BASE_URL + "/get-topSkillValidity",
              DataEncryption({
                primarySkill: skillsToValidate,
                type: "skill-relevance",
              }),
              {
                options: {
                  type: "json",
                },
              }
            )
            .then((response) => {
              const data = DataDecryption(response.data);

              // Handle duplicates
              let lastDuplicateIndex = -1;
              data.topPrimarySkill.forEach((skill, index) => {
                if (skill.isDuplicate) {
                  lastDuplicateIndex = index;
                }
              });

              if (lastDuplicateIndex !== -1) {
                // Filter out duplicates
                const filterSkills = data.topPrimarySkill.filter(
                  (item) => item.isDuplicate === false
                );
                setAutoValue(filterSkills);
                setTopSkillValidity(filterSkills);
                setValue("primarySkill", filterSkills);
                setSynonyms(filterSkills);
              } else {
                // No duplicates, use all skills
                setAutoValue(data.topPrimarySkill);
                setTopSkillValidity(data.topPrimarySkill);
                setValue("primarySkill", data.topPrimarySkill);
                setSynonyms(data.topPrimarySkill);
              }

              setSkillLoading(false);

              // Enable auto-click if not already executed
              if (!autoClickExecutedRef.current) {
                setShouldAutoClick(true);
              }
            })
            .catch((error) => {
              console.error("Error validating skills on mount:", error);
              setSkillLoading(false);
              mountValidationRef.current = false; // Reset on error to allow retry
            });
        }
      }
    }, 500); // Wait for skills to be set from localStorage

    return () => clearTimeout(checkTimer);
  }, [routerLocation.pathname, methods, autoValue, topSkillValidity, skillLoading, setValue, setSynonyms, setTopSkillValidity]);

  // Auto-click the Check Relevance button when skills are prefilled from CVScore
  // Multiple safeguards to prevent duplicate clicks
  useEffect(() => {
    // Guard 1: Check all required conditions
    if (
      !shouldAutoClick ||
      autoValue.length === 0 ||
      loadingButton ||
      skillLoading ||
      !skillValidationComplete || // Guard 2: Skill validation must be complete
      autoClickExecutedRef.current || // Guard 3: Already executed check
      isSubmittingRef.current // Guard 4: Already submitting check
    ) {
      return; // Exit early if any condition fails
    }

    // No need to wait - skill validation is already complete
    // Guard 5: Double-check before execution
    if (autoClickExecutedRef.current || isSubmittingRef.current) {
      return;
    }

    // Check if skills have been processed (have proper styling/metadata)
    const hasProcessedSkills = autoValue.some(
      (skill) => skill.imgPath || skill.estYear || skill.score !== undefined
    );

    if (hasProcessedSkills || autoValue.length > 0) {
      // Guard 6: Mark as executed IMMEDIATELY to prevent race conditions
      autoClickExecutedRef.current = true;
      isSubmittingRef.current = true;

      // Disable auto-click state
      setShouldAutoClick(false);

      // Small delay to ensure flags are set
      setTimeout(() => {
        try {
          // Get the current form data
          const formData = methods.getValues();
          formData.primarySkill = autoValue;

          // Call the onSubmit function directly
          onSubmit(formData);
        } catch (error) {
          console.error("Error during auto-click submission:", error);
          // Reset flags on error
          autoClickExecutedRef.current = false;
          isSubmittingRef.current = false;
        }
      }, 50);
    }
  }, [
    shouldAutoClick,
    autoValue,
    loadingButton,
    skillLoading,
    skillValidationComplete,
    onSubmit,
    methods,
  ]);

  var cancelToken = null;
  function getSkillOptions(
    setData,
    endpoint,
    setLoading,
    setErrorWithStatus,
    setErrorAPI
  ) {
    setData([]);
    setLoading(true);

    if (cancelToken) {
      cancelToken.cancel("Previous request cancelled");
    }

    try {
      cancelToken = axios.CancelToken.source();

      axios
        .get(process.env.REACT_APP_API_BASE_URL + endpoint, {
          cancelToken: cancelToken.token,
        })
        .then((object) => {
          if (object?.status === 201) {
            const data = _.remove(
              DataDecryption(object.data),
              (n) => n.name !== "Other"
            );
            setData(data);
          } else {
            setData([]);
          }
          setLoading(false);
          setErrorAPI(false);
        })
        .catch((error) => {
          if (axios.isCancel(error)) {
            console.info("Request canceled:", error.message); // Log the cancellation
          } else {
            // Handle other errors
            let errorMessage = "An unexpected error occurred";
            let errorStatus = null;

            if (error?.response) {
              errorStatus = error.response.status;

              if (errorStatus === 500) {
                errorMessage = "Server error occurred. Please try again later.";
              } else if (errorStatus === 404) {
                errorMessage = "Endpoint not found. Please check the URL.";
              } else if (errorStatus >= 400) {
                errorMessage = "Client-side error occurred.";
              }
            } else {
              // Handle network errors
              errorMessage = "Network error, please check your connection.";
            }

            // Set error message and status
            setErrorWithStatus({ message: errorMessage, status: errorStatus });
            console.error("Error:", errorMessage);
            setErrorAPI(true);
            setTimeout(() => {
              setLoading(false);
            }, 2000);
          }
        });
    } catch (error) {
      // Handle unexpected errors
      setErrorWithStatus({
        message: "An unexpected error occurred",
        status: null,
      });
      console.error("Error:", error);
      setTimeout(() => {
        setLoading(false);
      }, 2000);
      setErrorAPI(true);
    }
  }

  // function to add subskills into main skill input

  function addSkillRelevance(skill) {
    const restSkills = skillList;
    setValue("primarySkill", [...restSkills, skill?.skillName]);
    const newSkils = [...autoValue, { name: skill?.skillName }];
    setAutoValue(newSkils);
    setAddSkill(true);
  }

  return (
    <ThemeProvider theme={relevenceTheme}>
      <React.Fragment>
        <BookmarkNavigation
          isLoggedIn={isLoggedIn}
          relevanceResult={relevanceResult}
          loadingButton={loadingButton}
          loading={loading}
          checkSkill={checkSkill}
          poweredByChatGPT={poweredByChatGPT}
          chatgptError={chatgptError}
          chatGptButton={chatGptButton}
          chatGPTData={chatGPTData}
        />
        {/* Techrelevance Header section */}
        <Grid
          container
          display={"flex"}
          flexDirection={"row"}
          justifyContent={{
            xs: "center",
            sm: "space-between",
            md: "center",
            lg: "space-between",
          }}
          sx={{
            position: "sticky",
            top: 0,
            backgroundColor: "#fff",
            zIndex: 1,
            alignItems: "center",
          }}
        >
          {/* Header Section */}

          <Grid
            item
            xs={4.8}
            sm={5.5}
            order={{ sm: 1, md: 2 }}
            sx={{
              justifyContent: { sm: "flex-start", md: "flex-end" },
              display: "flex",
            }}
          >
            {isSmallDevice ? (
              <IconButton onClick={toggleDrawer(true)}>
                <MenuIcon />
              </IconButton>
            ) : (
              <Grid item>
                {isLoggedIn && (
                  <Box
                    sx={{
                      pr: 3,
                    }}
                  >
                    <Button
                      sx={{
                        borderRadius: "55px",
                        textTransform: "capitalize",
                        backgroundImage:
                          "linear-gradient(to right, rgba(74,61,158,1), rgba(108,82,229,1) )",
                        border: "1px solid transparent",
                        transition: "all 0.3s linear",
                        "&:hover": {
                          border: "1px solid rgba(74,61,158,1)",
                          background: "#FFF",
                          color: "rgba(108,82,229,1)",
                          transition: "all 0.3s linear",
                        },
                      }}
                      variant="contained"
                      endIcon={<LogoutIcon />}
                      onClick={handleOpen}
                    >
                      Logout
                    </Button>
                  </Box>
                )}
              </Grid>
            )}

            <Drawer
              anchor="left"
              open={drawerOpen}
              onClose={toggleDrawer(false)}
            >
              <Box
                sx={{ width: 250 }}
                role="presentation"
                onClick={toggleDrawer(false)}
                onKeyDown={toggleDrawer(false)}
              >
                <List>
                  <ListItem
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Box
                      sx={{
                        p: { xs: 1, md: 2, xl: 2 },
                        display: "flex",
                        justifyContent: "center",
                        maxWidth: { xs: "60px", md: "60px", lg: "80px" },
                      }}
                    >
                      <a href="/">
                        <img
                          src={"../../assets/images/TrueSelfy-logo.svg"}
                          alt="true-selfy"
                          loading="lazy"
                          style={{
                            maxWidth: `${isMobile ? "80px" : "80px"}`,
                            width: "100%",
                          }}
                        />
                      </a>
                    </Box>
                  </ListItem>
                  {isLoggedIn && (
                    <ListItem button onClick={handleOpen}>
                      <ListItemIcon>
                        <LogoutIcon />
                      </ListItemIcon>
                      <ListItemText primary="Logout" />
                    </ListItem>
                  )}
                </List>
              </Box>
            </Drawer>
          </Grid>
          <Grid item xs={7.2} sm={6.5} order={{ sm: 2, md: 1 }}>
            <Box
              sx={{
                p: { xs: 1, md: 2, xl: 2 },
                display: "flex",
                justifyContent: "center",
                maxWidth: { xs: "60px", md: "60px", lg: "80px" },
              }}
            >
              <a href="/">
                <img
                  src={"../../assets/images/TrueSelfy-logo.svg"}
                  alt="true-selfy"
                  loading="lazy"
                  style={{
                    maxWidth: `${isMobile ? "80px" : "80px"}`,
                    width: "100%",
                  }}
                />
              </a>
            </Box>
          </Grid>

          <Modal
            open={openLogout}
            onClose={handleClose}
            aria-labelledby="logout-modal-title"
            aria-describedby="logout-modal-description"
          >
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: 300,
                bgcolor: "background.paper",
                border: "2px solid #000",
                boxShadow: 24,
                p: 4,
              }}
            >
              <Grid
                container
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography id="logout-modal-title" variant="h6" component="h2">
                  Confirm Logout
                </Typography>
                <IconButton onClick={handleClose}>
                  <CloseIcon />
                </IconButton>
              </Grid>
              <Typography id="logout-modal-description" sx={{ mt: 2 }}>
                Are you sure you want to logout?
              </Typography>
              <Grid container justifyContent="space-between" sx={{ mt: 4 }}>
                <Button
                  sx={{ borderRadius: "55px" }}
                  onClick={handleLogout}
                  variant="contained"
                  color="primary"
                >
                  Yes
                </Button>
                <Button
                  sx={{ borderRadius: "55px" }}
                  onClick={handleClose}
                  variant="outlined"
                  color="secondary"
                >
                  No
                </Button>
              </Grid>
            </Box>
          </Modal>
        </Grid>
        <Modal
          open={openCountryModal}
          onClose={handleCloseModal}
          hideBackdrop={false}
          aria-labelledby="country-modal-title"
          aria-describedby="country-modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: { xs: 300, sm: 400 },
              bgcolor: "background.paper",
              border: "2px solid #000",
              boxShadow: 24,
              p: 4,
              borderRadius: "16px",
            }}
          >
            {/* Close Button */}
            <IconButton
              onClick={handleCloseModal}
              sx={{
                position: "absolute",
                top: 8,
                right: 8,
                color: (theme) => theme.palette.grey[500],
              }}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>

            <Typography id="country-modal-title" variant="h6" component="h2">
              Select Your Location
            </Typography>

            <Box sx={{ mt: 2 }}>
              <Autocomplete
                options={countries}
                getOptionLabel={(option) => option.name}
                onChange={(event, value) => handleCountrySelect(value)}
                renderInput={(params) => (
                  <TextField {...params} label="Select Country" fullWidth />
                )}
                sx={{ mb: 2 }}
              />

              {selectedCountry && (
                <>
                  {isStateLoading ? (
                    <Skeleton
                      variant="rectangular"
                      height={56}
                      sx={{ mb: 2, borderRadius: "4px" }}
                    />
                  ) : (
                    <Autocomplete
                      options={stateList}
                      getOptionLabel={(option) => option.name}
                      onChange={(event, value) => handleStateSelect(value)}
                      renderInput={(params) => (
                        <TextField {...params} label="Select State" fullWidth />
                      )}
                      sx={{ mb: 2 }}
                    />
                  )}
                </>
              )}

              <Button
                variant="contained"
                onClick={handleModalSubmit}
                sx={{ mt: 2, width: "100%", borderRadius: "55px" }}
              >
                Submit
              </Button>
            </Box>
            <Typography
              variant="body2"
              sx={{ color: "text.secondary", mt: 1, mb: 2 }}
              id="country-modal-description"
            >
              Providing your location helps us personalize salary insights and
              show more relevant data based on your region.
            </Typography>
          </Box>
        </Modal>
        {/* Techrelevance first Section */}
        <>
          {loading ? (
            <>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: {
                    xs: "68vh",
                    sm: "68vh",
                    md: "70vh",
                    lg: "78vh",
                  },
                  width: "100%",
                  overflow: "hidden",
                }}
                // position="fixed"
              >
                {isMobile ? (
                  <img
                    src={"../../../assets/images/loading-mobile.gif"}
                    alt="loading..."
                    loading="lazy"
                  />
                ) : (
                  <img
                    src={"../../../assets/images/loader3.gif"}
                    alt="loading..."
                    loading="lazy"
                  />
                )}
              </Box>
            </>
          ) : (
            <>
              {/* User Details Section */}
              {isLoggedIn ? (
                <Grid
                  container
                  alignItems={"flex-start"}
                  p={{
                    xs: "15px",
                    sm: "20px 50px",
                    md: "0px 50px",
                    lg: "30px 40px 0px 40px",
                    xl: "30px 70px 0px 70px",
                  }}
                  justifyContent={"center"}
                >
                  <Grid
                    item
                    xs={12}
                    id={"enter-your-skills"}
                    sx={{ minHeight: "50vh" }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 2,
                        mb: {
                          xs: "18px",
                          sm: "22px",
                          md: "18px",
                          lg: "37px",
                          xl: "37px",
                        },
                        mt: { xs: 0, sm: 0, md: "18px", lg: "0px" },
                      }}
                    >
                      {renderCustomIcon("enter-skills", 60)}
                      <Typography
                        sx={{
                          fontFamily: "poppins",
                          fontWeight: 700,
                          fontSize: { xs: "24px", sm: "30px", md: "45px" },
                          textAlign: "center",
                          wordBreak: "break-word",
                          color: "#020D17",
                        }}
                      >
                        Enter any{" "}
                        <span style={{ color: "#6652E4" }}>topic</span>,{" "}
                        <span style={{ color: "#6652E4" }}>domain</span>,{" "}
                        <span style={{ color: "#6652E4" }}>skill</span>,{" "}
                        <span style={{ color: "#6652E4" }}>role</span>, or{" "}
                        <span style={{ color: "#6652E4" }}>activity</span>
                      </Typography>
                    </Box>
                    <React.Fragment>
                      <FormProvider {...methods}>
                        <form
                          id="tech-relevance"
                          onSubmit={methods.handleSubmit(onSubmit)}
                        >
                          <TechRelevanceForm
                            setSkillLoading={setSkillLoading}
                            setRelevanceResult={setRelevanceResult}
                            methods={methods}
                            DataDecryption={DataDecryption}
                            DataEncryption={DataEncryption}
                            setTopSkillValidity={setTopSkillValidity}
                            setSynonyms={setSynonyms}
                            setAutoValue={setAutoValue}
                            shouldAutoFocus={shouldAutoFocus}
                            setShouldAutoFocus={setShouldAutoFocus}
                            getEmail={getEmail}
                            skillLength={skillLength}
                            autoValue={autoValue}
                            topSkillValidity={topSkillValidity}
                            deviceInfo={deviceInfo}
                            addSkill={addSkill}
                            onSubmit={onSubmit}
                            setErrorWithStatus={setErrorWithStatus}
                            setErrorAPI={setErrorAPI}
                            location={location}
                            getSkillOptions={getSkillOptions}
                            skillLoading={skillLoading}
                            shouldAutoClick={shouldAutoClick}
                            autoClickExecutedRef={autoClickExecutedRef}
                            onSkillValidationComplete={
                              handleSkillValidationComplete
                            }
                          />
                          <Grid>
                            <Box py={4}>
                              {loadingButton ? (
                                <Grid item xs={12}>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      justifyContent: "center",
                                      my: 5,
                                    }}
                                  >
                                    <Loading />
                                  </Box>
                                </Grid>
                              ) : (
                                <Button
                                  id={"check-relevance-button"}
                                  type="submit"
                                  form="tech-relevance"
                                  // variant="contained"
                                  sx={{
                                    maxWidth: "333px",
                                    width: "100%",
                                    display: "block",
                                    m: "0px auto",
                                    color: "#FFF",
                                    P: "12px",
                                    fontSize: "24px",
                                    fontWeight: 600,
                                    borderRadius: "55px",
                                    textTransform: "capitalize",
                                    backgroundImage:
                                      "linear-gradient(to right, rgba(74,61,158,1), rgba(108,82,229,1) )",
                                    border: "1px solid transparent",
                                    transition: "all 0.3s linear",
                                    "&:hover": {
                                      border: "1px solid rgba(74,61,158,1)",
                                      background: "#FFF",
                                      color: "rgba(108,82,229,1)",
                                      transition: "all 0.3s linear",
                                    },
                                  }}
                                  loading={loadingButton}
                                  disabled={skillLoading}
                                >
                                  {" "}
                                  Check Relevance
                                </Button>
                              )}
                            </Box>
                          </Grid>
                        </form>
                        {!loadingButton &&
                          topSkillValidity.length > 0 &&
                          synonyms.some(
                            (item) =>
                              Array.isArray(item.synonyms) &&
                              item.synonyms.length > 0
                          ) &&
                          autoValue.length > 0 && (
                            <SynonymsInfoBox topSkillValidity={synonyms} />
                          )}
                      </FormProvider>
                      {errorAPI && (
                        <Box>
                          <ErrorComponent errorWithStatus={errorWithStatus} />
                          <Typography>{errorAPI}</Typography>
                        </Box>
                      )}
                    </React.Fragment>
                  </Grid>
                  <FeaturesCardSwiper />
                </Grid>
              ) : (
                ""
              )}
              {/* <SignInModal setOpen={setOpen} open={open} userData={userData} /> */}
              {/* Tech relevance Section */}
              {relevanceResult?.length !== 0 &&
              relevanceResult !== undefined &&
              !loadingButton &&
              loading === false &&
              isLoggedIn ? (
                <>
                  <Joyride
                    steps={introSteps}
                    run={run}
                    showSkipButton
                    continuous
                    disableCloseOnEsc
                    disableOverlayClose
                    disableScrolling
                  />
                  <motion.div
                    initial={{ opacity: 0.6, y: 200 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, y: -200 }}
                    transition={{ duration: 1 }}
                  >
                    <Grid
                      container
                      p={{
                        xs: "15px",
                        sm: "20px 50px",
                        md: "0px 50px",
                        lg: "30px 40px 0px 40px",
                        xl: "30px 70px 0px 70px",
                      }}
                    >
                      <Grid item xs={12} id={"relevance-result"}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: 2,
                            mb: "37px",
                            mt: { xs: "64px", sm: 10 },
                          }}
                        >
                          {renderCustomIcon("relevance-result", 45)}
                          <Typography
                            // color={"primary"}
                            sx={{
                              fontFamily: "poppins",
                              fontSize: { xs: "30px", md: "45px" },
                              textAlign: "center",
                              fontWeight: 600,
                              wordBreak: "break-word",
                              color: "#020D17",
                            }}
                          >
                            How long you will remain relevant ?
                          </Typography>
                        </Box>
                        <Grid
                          container
                          spacing={{ xs: 2, md: 5 }}
                          rowSpacing={1}
                        >
                          <Grid item xs={12} md={6}>
                            <Box
                              component="div"
                              sx={{
                                p: {
                                  xs: "25px",
                                  md: "30px",
                                  lg: "30px",
                                  xl: "60px",
                                },
                                border: "1px solid rgba(102,82,228,0.25)",
                                borderRadius: "39px",
                                boxShadow: "0px 0px 8px 0px #D9D9FF",
                                height: "100%",
                                boxSizing: "inherit",
                              }}
                            >
                              <Box
                                className="technical-validity-box"
                                sx={{
                                  background: "#fff",
                                  display: "flex",
                                  flexDirection: { xs: "column", xl: "row" },
                                  alignItems: { xs: "center", xl: "unset" },
                                }}
                              >
                                <Box
                                  sx={{
                                    maxWidth: { xs: "188px", xl: "188px" },
                                    width: "100%",
                                    height: "auto",
                                    mb: "36px",
                                    displays: "auto",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    mb: { md: "36px", lg: "0px" },
                                    pr: { lg: "20px" },
                                  }}
                                >
                                  <img
                                    src="/assets/images/timer2.gif"
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      maxWidth: "192px",
                                    }}
                                    alt="check-icon"
                                    loading="lazy"
                                  />
                                </Box>
                                <Box
                                  sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  <Typography
                                    color="primary"
                                    sx={{
                                      fontFamily: "poppins",
                                      fontSize: "32px",
                                      fontWeight: 700,
                                      textAlign: {
                                        xs: "center",

                                        xl: "start",
                                      },
                                      color: "#020D17",
                                    }}
                                  >
                                    Top Skill Validity Until
                                  </Typography>
                                  <Typography
                                    sx={{
                                      fontFamily: "poppins",
                                      fontSize: "65px",
                                      fontWeight: 700,
                                      textAlign: {
                                        xs: "center",

                                        xl: "start",
                                      },
                                      color: "#6652E4",
                                      lineHeight: "1.1",
                                    }}
                                  >
                                    {
                                      getTopSkill(
                                        relevanceResult?.topPrimarySkill
                                      ).maxExpiryYear
                                    }
                                    <Typography variant="subtitle2">
                                      (approximately)
                                    </Typography>
                                  </Typography>
                                  <Typography
                                    sx={{
                                      fontFamily: "poppins",
                                      fontWeight: 700,
                                      textAlign: {
                                        xs: "center",

                                        xl: "start",
                                      },
                                      lineHeight: "1.1",
                                    }}
                                  >
                                    {
                                      getTopSkill(
                                        relevanceResult?.topPrimarySkill
                                      )?.labelSuggestion
                                    }
                                  </Typography>
                                </Box>
                              </Box>
                            </Box>
                          </Grid>

                          <Grid item xs={12} md={6}>
                            <Box
                              component="div"
                              sx={{
                                p: { xs: "25px", md: "35px" },
                                border: "2px solid rgba(102,82,228,0.25)",
                                borderRadius: "39px",
                                boxShadow: "0px 0px 8px 0px #D9D9FF",
                                height: "100%",
                                boxSizing: "inherit",
                              }}
                            >
                              <Grid
                                container
                                alignItems={"center"}
                                sx={{ mb: isMobile ? "5px" : "0px" }}
                                justifyContent={{
                                  xs: "center",
                                  lg: "space-between",
                                }}
                              >
                                <Grid item xs={12} lg={8}>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      gap: 2,
                                      alignItems: "center",
                                      justifyContent: {
                                        xs: "center",
                                        lg: "flex-start",
                                      },
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        maxWidth: { xs: "46px", md: "58px" },
                                        height: "100%",
                                        width: "100%",
                                      }}
                                    >
                                      <img
                                        src="/assets/images/skill-score-relevance-01.svg"
                                        width={"100%"}
                                        height="auto"
                                        alt="skill-score"
                                        loading="lazy"
                                      />
                                    </Box>

                                    <Typography
                                      sx={{
                                        fontFamily: "poppins",
                                        fontWeight: 700,
                                        fontSize: { xs: "28px", md: "32px" },
                                        letterSpacing: "0.5px",
                                        color: "#262655",
                                      }}
                                      variant="h5"
                                    >
                                      Skill score
                                    </Typography>
                                  </Box>
                                </Grid>
                                {!isMobile && (
                                  <Grid item xs={0} lg={4}>
                                    <Box
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <Box>
                                        <Typography
                                          sx={{
                                            fontFamily: "poppins",
                                            fontSize: {
                                              sm: "18px",
                                              xl: "24px",
                                            },
                                            fontWeight: 700,
                                            textAlign: {
                                              xs: "center",
                                              md: "center",
                                              lg: "center",
                                            },
                                            wordBreak: "break-word",
                                            color: "#262655",
                                            mr: "5px",
                                          }}
                                        >
                                          Career Insights by ChatGPT
                                        </Typography>
                                      </Box>
                                      <Box>
                                        <img
                                          style={{ maxWidth: "40px" }}
                                          src="/assets/images/chat-gpt-logo.svg"
                                          alt="powered-by-chat-gpt"
                                          loading="lazy"
                                        />
                                      </Box>
                                    </Box>
                                  </Grid>
                                )}
                                {autoValue?.length >= 5 && (
                                  <Grid item xs={12}>
                                    <Box sx={{ py: 1 }}>
                                      <Alert
                                        severity="success"
                                        sx={{ alignItems: "center" }}
                                      >
                                        Displaying the top 5 skills based on the
                                        most recent validity year.
                                      </Alert>
                                    </Box>
                                  </Grid>
                                )}
                              </Grid>

                              {relevanceResult?.topPrimarySkill?.map(
                                (item, index) => {
                                  return (
                                    <Box
                                      sx={{
                                        display: "flex",
                                        gap: { xs: 2, lg: 2, xl: 15 },
                                        alignItems: {
                                          xs: "center",
                                          sm: "flex-end",
                                          md: "center",
                                          lg: "flex-end",
                                          xl: "flex-end",
                                        },
                                        justifyContent: "space-between",
                                        my: { xs: "20px", md: "30px" },
                                      }}
                                      flexDirection={{
                                        xs: "column",
                                        sm: "row",
                                        md: "column",
                                        lg: "row",
                                        xl: "row",
                                      }}
                                      key={item._id}
                                    >
                                      <Box
                                        flexGrow={1}
                                        sx={{
                                          width: "100%",
                                          background: "#fff",
                                          maxWidth: "700px",
                                        }}
                                        className={"skill-score"}
                                      >
                                        <Typography
                                          sx={{
                                            fontFamily: "poppins",
                                            fontSize: "22px",
                                            fontWeight: 700,
                                            display: "block",
                                            mb: "6px",
                                            mr: "20px",
                                          }}
                                        >
                                          {item?.name}
                                        </Typography>

                                        <Box
                                          sx={{
                                            display: "flex",
                                            gap: 2,
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                          }}
                                        >
                                          <Typography
                                            sx={{
                                              fontSize: "18px",
                                              color: "#262655",
                                            }}
                                          >
                                            {item.type === "y"
                                              ? checkYear(item?.expiryYear)
                                                  .label
                                              : checkSkillType(
                                                  item?.expiryYear
                                                )}
                                          </Typography>
                                          <Typography
                                            sx={{
                                              fontSize: "24px",
                                              fontWeight: 700,
                                            }}
                                            color={
                                              checkYear(item?.expiryYear)
                                                ?.percentageColor
                                            }
                                          >
                                            {item?.score <= 0
                                              ? "20"
                                              : item?.score > 100
                                              ? "80"
                                              : Math.round(item?.score)}
                                            %
                                          </Typography>
                                        </Box>
                                        <Box sx={{ width: "100%" }}>
                                          <LinearProgress
                                            sx={{
                                              height: "10px",
                                              borderRadius: "20px",
                                              "& .MuiLinearProgress-bar": {
                                                backgroundColor: checkYear(
                                                  item?.expiryYear
                                                ).barPrimaryColor,
                                              },
                                              backgroundColor: checkYear(
                                                item?.expiryYear
                                              ).barSecondaryColor,
                                            }}
                                            color="error"
                                            variant="determinate"
                                            value={
                                              item?.score <= 0
                                                ? 20
                                                : item?.score > 100
                                                ? 80
                                                : Math.round(item?.score)
                                            }
                                          />
                                        </Box>
                                      </Box>

                                      {poweredByChatGPT && (
                                        <GlowBorderWrapper>
                                          <Button
                                            sx={{
                                              width: "200px",
                                              // maxWidth: "200px",
                                              color: "#fff",
                                              alignItems: "center",
                                              border:
                                                "1px solid rgba(74,61,158,1)",
                                              justifyContent: "space-evenly",
                                              padding: "7px 12px",
                                              borderRadius: "27px",
                                              background:
                                                "linear-gradient(to right, rgba(74,61,158,1), rgba(108,82,229,1))",
                                              transition: "all 0.3s linear",
                                              "&:disabled": {
                                                background:
                                                  "rgba(108,82,229,0.5)",
                                                color: "#fff",
                                                cursor: "not-allowed",
                                              },
                                            }}
                                            className="get-insights btn-anim"
                                            startIcon={
                                              <Box>
                                                <EmojiIcon
                                                  lottieFiles={[ai]}
                                                  interval={4000}
                                                />
                                              </Box>
                                            }
                                            endIcon={
                                              <Box>
                                                <EmojiIcon
                                                  lottieFiles={[ai]}
                                                  interval={4000}
                                                />
                                              </Box>
                                            }
                                            onClick={() =>
                                              handleSendClick(item)
                                            }
                                            disabled={processingSkill !== null}
                                          >
                                            {processingSkill === item.name ? (
                                              <CircularProgress
                                                size={20}
                                                sx={{ color: "#fff" }}
                                              />
                                            ) : (
                                              "Ask AI"
                                            )}
                                          </Button>
                                        </GlowBorderWrapper>
                                      )}
                                    </Box>
                                  );
                                }
                              )}
                            </Box>
                          </Grid>

                          <Grid item xs={12}>
                            <Box textAlign={"left"} pt={0.5}>
                              <Alert
                                severity="info"
                                sx={{ background: "#fff" }}
                              >
                                Recommendations and potential salary increase
                                percentages provided are for informational
                                purposes only and should be used as suggestions,
                                not guarantees
                              </Alert>
                            </Box>
                          </Grid>
                        </Grid>
                      </Grid>
                      {/* AI Boost powered Section */}
                      <Grid item xs={12}>
                        <Grid
                          container
                          spacing={5}
                          sx={{ alignItems: "flex-end" }}
                        >
                          {checkSkill !== "" &&
                          poweredByChatGPT &&
                          !chatgptError ? (
                            <Grid item xs={12} xl={12} id={"chat-gpt-result"}>
                              <Joyride
                                steps={InsightsSteps}
                                run={insightsStep}
                                showSkipButton
                                continuous
                                disableCloseOnEsc
                                disableOverlayClose
                                disableScrolling
                              />

                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  mb: "52px",
                                  mt: { xs: "45px", sm: "0px" },
                                }}
                              >
                                <Box sx={{ px: 1 }}>
                                  <Typography
                                    color={"primary"}
                                    sx={{
                                      fontFamily: "poppins",
                                      fontSize: { xs: "30px", md: "45px" },
                                      fontWeight: 600,
                                      textAlign: "center",
                                      wordBreak: "break-word",
                                      color: "#020D17",
                                    }}
                                  >
                                    Career Insights by ChatGPT
                                  </Typography>
                                </Box>

                                <Box>
                                  <img
                                    src="/assets/images/chat-gpt-logo.svg"
                                    alt="powered-by-chat-gpt"
                                    loading="lazy"
                                  />
                                </Box>
                              </Box>
                              {/* Career Insights by ChatGPT section */}
                              {chatGptButton && (
                                <Box sx={{ mb: 4 }}>
                                  <InsightsAnimation
                                    isVisible={true}
                                    onAnimationComplete={
                                      handleAnimationComplete
                                    }
                                  />
                                </Box>
                              )}
                              {chatGptButton ? (
                                <InsightsSkeleton />
                              ) : (
                                <GetInsights
                                  checkSkill={checkSkill}
                                  subSkills={subSkills}
                                  chatGptButton={chatGptButton}
                                  chatGPTData={chatGPTData}
                                  interviewQuestionsLoading={
                                    interviewQuestionsLoading
                                  }
                                  advancedQuestionsLoading={
                                    advancedQuestionsLoading
                                  }
                                  intermediateQuestionsLoading={
                                    intermediateQuestionsLoading
                                  }
                                  basicQuestionsLoading={basicQuestionsLoading}
                                  interviewQuestions={interviewQuestions}
                                  disruptCareerData={disruptCareerData}
                                  Hide_google_trends={Hide_google_trends}
                                  RetryGPT={RetryGPT}
                                  addSkillRelevance={addSkillRelevance}
                                  easeOfLearning={easeOfLearning}
                                  PotentialSalaryIncraese={
                                    PotentialSalaryIncraese
                                  }
                                  isMobile={isMobile}
                                  initialCount={initialCount}
                                  randomIntFromInterval={randomIntFromInterval}
                                  setDisruptCareerLoading={
                                    setDisruptCareerLoading
                                  }
                                  disruptCareerLoading={disruptCareerLoading}
                                  advancedQuestions={advancedQuestions}
                                  setAdvancedQuestions={setAdvancedQuestions}
                                  intermediateQuestions={intermediateQuestions}
                                  setIntermediateQuestions={
                                    setIntermediateQuestions
                                  }
                                  basicQuestions={basicQuestions}
                                  setBasicQuestions={setBasicQuestions}
                                  selectedTab={selectedTab}
                                  setSelectedTab={setSelectedTab}
                                  onQuestionSubmit={onQuestionSubmit}
                                  JobSuggestionData={JobSuggestionData}
                                  setJobSuggestionData={setJobSuggestionData}
                                  questionFormLoading={questionFormLoading}
                                  questions={questions}
                                  methodsJobSuggestion={methodsJobSuggestion}
                                  formVisible={formVisible}
                                  setFormVisible={setFormVisible}
                                  address={address}
                                />
                              )}
                            </Grid>
                          ) : (
                            ""
                          )}
                        </Grid>
                      </Grid>
                    </Grid>
                  </motion.div>
                </>
              ) : (
                ""
              )}
            </>
          )}
        </>
        <Box
          sx={{
            position: {
              lg: "unset",
              sm: "unset",
              xs: "unset",
              md: "unset",
              xl: "unset",
            },
            bottom: "0px",
            width: "100%",
            mt: {
              xs: isLoggedIn && relevanceResult !== "" ? 22 : 2,
              sm: isLoggedIn && relevanceResult !== "" ? 28 : 2,
              lg: isLoggedIn && relevanceResult !== "" ? 22 : 2,
            },
          }}
        >
          <FooterComponent />
        </Box>
        <Toaster
          position="top-center"
          limit={1}
          toastOptions={{
            style: {
              wordBreak: "break-all",
              maxWidth: 800,
            },
          }}
        >
          {(t) => (
            <ToastBar
              toast={t}
              style={{
                // overflowWrap: "break-word",
                wordBreak: "break-all",
              }}
            >
              {({ icon, message }) => (
                <>
                  {icon}
                  {message}
                  {t.type !== "loading"}
                </>
              )}
            </ToastBar>
          )}
        </Toaster>
      </React.Fragment>
    </ThemeProvider>
  );
}

export default TechRelevanceV4;
